import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { LoginResponseDocumentation } from "../types/enums";

interface IProtectedRoute {
	component: JSX.Element;
}

const ProtectedRoute = ({ component }: IProtectedRoute) => {
	const token = useSelector((state: any) => state.auth.token);
	const isLoggedIn = !!token;
	if (!isLoggedIn) {
		return <Navigate to={"/login"} replace />;
	}
	return component;
};

export default ProtectedRoute;
